// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { floppyDisk16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-floppy-disk': IconFloppyDisk;
    }
}

/**
 * The icon component for the 'floppyDisk' icon
 */
export class IconFloppyDisk extends IconSvg {
    public constructor() {
        super(floppyDisk16X16);
    }
}

registerIconSvg('icon-floppy-disk', IconFloppyDisk);
export const iconFloppyDiskTag = 'nimble-icon-floppy-disk';
